// Where to pickup CDN resources from
// We assume we are loaded from <script id='ui-bundle'>, so we strip the filename from the `src`
// (we look for last `/` and strip everything after it)
__webpack_public_path__ = document.querySelector('script[id=ui-bundle]').src.replace(/\/[^/]+$/, '/');



/** WEBPACK FOOTER **
 ** ./src/cdn.js
 **/